const pagos = {
    BuscarPagos: 'SIVAC/Caja/BuscarPagos',
    BuscarPagosCancelar: 'SIVAC/Caja/BuscarPagosCancelar',
    BuscarPagosDevolver: 'SIVAC/Caja/BuscarPagosDevolver',
    BuscarPagosQR: 'SIVAC/Caja/BuscarPagosQR',
    ObtenerTiposDeDocumentosIdYDBId : 'SIVAC/Caja/ObtenerTiposDeDocumentosIdYDBId',
    ActualizarEstatusImpresion: 'SIVAC/Caja/ActualizarEstatusImpresion',
    InhabilitarPagos: 'SIVAC/Caja/InhabilitarPagos',
    DevolverPagos: 'SIVAC/Caja/DevolverPagos',
    EliminarDevolucionPagos: 'SIVAC/Caja/EliminarDevolucionPagos',
    ActualizarEstatusDevolucion: 'SIVAC/Caja/ActualizarEstatusDevolucion',
    BuscarDevolucion: 'SIVAC/Caja/BuscarDevolucion'    
}

const caja = {
    pagos: pagos
}

export default caja;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SIVAC/Sistema/Caja/caja.js
// module id = null
// module chunks = 